import { render } from "./Time_Policy.vue?vue&type=template&id=4acefd96"
import script from "./Time_Policy.vue?vue&type=script&lang=js"
export * from "./Time_Policy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__